var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-not-found"},[_c('div',{staticClass:"inner"},[_c('h1',[_vm._v("Not Found")]),_vm._v(" Oops! Something went wrong. Please try again later. ")])])
}]

export { render, staticRenderFns }